import type {ReactAction} from '@netx/core/bootstrap';
import {faPlus} from '@fortawesome/pro-solid-svg-icons';
import {canCategorizeAddCurrentCartAssets} from '../enablers';
import {CART_CURRENT_ACTION_LABELS} from '../locales';
import {CART_CURRENT_EVENT} from './constants';

/**
 * Add cart assets to folder
 * @param params
 * @returns Action
 */
export const cartActionCategorizeAdd = (
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'cart-current-categorize-plus',
	cb: () => dispatcher.trigger(CART_CURRENT_EVENT.CATEGORIZE_ADD),
	enableTest: () => canCategorizeAddCurrentCartAssets(),
	icon: faPlus,
	get label() {
		return CART_CURRENT_ACTION_LABELS.CATEGORIZE_ADD;
	},
	...params,
});

export default cartActionCategorizeAdd;
